import { Box, Button, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { GLItemsDTO } from '../../../DTO/GLItemsDTO'
import { GLItemDTO, GLItemKind, GLItemStatus } from '../../../DTO/GLItemDTO'
import mainservice from '../../../services/MainService'

function personName(item: GLItemDTO): string {
  return item.person?.getDisplayName() || 'Ohne Person'
}

function customerName(item: GLItemDTO): string {
  return item.person?.customerName || 'Ohne Firma'
}

export default function LatestInquiriesModule(props: {
  variant?: 'teaser' | 'full'
}) {
  const variant = props.variant ?? 'teaser'
  const pageSize = variant === 'full' ? 20 : 6
  const [glitems] = useState(() => new GLItemsDTO({
    page: 1,
    limit: pageSize,
    kind: GLItemKind.marketing,
    status: GLItemStatus.generic,
  }))
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState<GLItemDTO[]>([])
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)

  async function load(p: number) {
    setLoading(true)
    await glitems.getPage(p)
    setItems([...glitems.items])
    setTotal(glitems.total)
    setPage(p)
    setLoading(false)
  }

  useEffect(() => {
    load(1)
  }, [])

  function openFull() {
    mainservice.navTo([['view', 'spMarketingLatest']])
  }

  function jump(item: GLItemDTO) {
    mainservice.navTo([
      ['view', 'spMarketing'],
      ['status', String(item.status)],
      ['id', item.id],
    ])
  }

  const pages = Math.max(1, Math.ceil(total / pageSize))

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: 1,
        padding: 2,
        minHeight: variant === 'teaser' ? 180 : 0,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ marginBottom: 1.5 }}>
        <Typography variant={variant === 'full' ? 'h5' : 'h6'} component="h3">
          Letzte Anfragen
        </Typography>
        {variant === 'teaser' && (
          <Button size="small" onClick={openFull} sx={{ textTransform: 'none' }}>Öffnen</Button>
        )}
      </Stack>
      {loading && <Box sx={{ color: '#666' }}>Lade…</Box>}
      {!loading && items.length === 0 && <Box sx={{ color: '#666' }}>Keine Anfragen</Box>}
      <Stack spacing={1}>
        {!loading && items.map(item => (
          <Box
            key={item.id}
            onClick={() => jump(item)}
            sx={{
              borderBottom: '1px solid #eee',
              paddingBottom: 1,
              cursor: 'pointer',
              '&:hover': { backgroundColor: '#f6f6f6' },
            }}
          >
            <Box sx={{ fontWeight: 600 }}>{item.headline || '(ohne Titel)'}</Box>
            <Box sx={{ color: '#555', fontSize: '0.9rem' }}>
              {customerName(item)} · {personName(item)}
            </Box>
          </Box>
        ))}
      </Stack>
      {variant === 'full' && pages > 1 && (
        <Stack direction="row" spacing={1} sx={{ marginTop: 2 }}>
          <Button size="small" disabled={page <= 1} onClick={() => load(page - 1)}>Zurück</Button>
          <Box sx={{ alignSelf: 'center' }}>{page} / {pages}</Box>
          <Button size="small" disabled={page >= pages} onClick={() => load(page + 1)}>Weiter</Button>
        </Stack>
      )}
    </Box>
  )
}
